<template>
  <v-row no-gutters>
    <v-col>
      <router-link
        class="
          align-center
          background-color-seashell
          d-inline-flex
          font-size-sm
          nav-button-border-radius
          pl-1
          pr-3
        "
        :to="{
          name: 'department',
          params: { departmentId: $route.params.departmentId },
        }"
      >
        <v-icon color="primary" class="">mdi-chevron-left</v-icon>
        Back to {{ textContent }} Page
      </router-link>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "RouteTo",
  props: {
    textContent: String,
  },
};
</script>
